export default {
  1: "زمینی",
  2: "هوایی",
  3: "پستی",
  4: "چاپار پلاس",
  5: "پاکت",
  6: "هوایی ماهکس",
  7: "پیشتاز",
  8: "سفارشی",
  9: "ویژه (sps)",
  10: "آوا باکس موتوری",
  11: "آوا باکس خودرویی",
  12: "تیپاکس زمینی",
  13: "اکسپرس",
  14: "بین شهری",
};
